import { isEditorImageNodeType } from './nodes/ImageNode';

interface SerializedNode {
  children?: SerializedNode[];
  text?: string;
  type?: string;
}

export const isWysiwygEmpty = (root?: Pick<SerializedNode, 'children'> | null) => {
  // If there is no root or no children, the node is empty
  if (!root || !Array.isArray(root.children) || root.children.length === 0) {
    return true;
  }

  // Check every child node in the root
  const isEmpty = root.children.every((node: SerializedNode) => isNodeEmpty(node));

  return isEmpty;
};

const isNodeEmpty = (node: SerializedNode): boolean => {
  if (node.type && isEditorImageNodeType(node.type)) {
    return false;
  }

  if (Array.isArray(node.children) && node.children.length > 0) {
    return node.children.every((child: SerializedNode) => isNodeEmpty(child));
  }
  return !node.text || node.text.trim() === '';
};
